import { html } from '@resn/gozer-core';

const getSmallestImage = (src) => {
    return typeof src === 'string' ? getOptimized(src).large : src.thumb || src.mobile || src.desktop;
};

export default ({
    src,
    className = '',
    classNamePicture = '',
    ui = 'img',
    fit = 'cover',
    position = 'center',
    loading = 'auto',
    fill = true,
    useOptimized = true,
} = {}) => {
    const isObject = typeof src === 'object';
    let desktop;

    if (isObject) desktop = getOptimized(src.desktop);

    return html`
        <picture class="pictureWrap ${classNamePicture}">
            ${isObject
                ? html`
                      ${useOptimized
                          ? html`
                                <source media="(max-width: 640px)" srcset="${src.mobile}" />
                                <source media="(max-width: 1599px)" srcset="${desktop.medium}" />
                                <source media="(min-width: 1600px)" srcset="${desktop.large}" />
                            `
                          : html`
                                <source media="(max-width: 640px)" srcset="${src.mobile}" />
                                <source media="(min-width: 641px)" srcset="${src.desktop}" />
                            `}
                  `
                : ''}
            <img
                class="js-picture picture ${className}"
                style="object-fit: ${fit}; object-position: ${position}"
                ?fill="${fill}"
                src="${getSmallestImage(src)}"
                alt="Image"
                data-ui=${ui}
                loading="${loading}"
                decoding="async"
            />
        </picture>
    `;
};

const getOptimized = (src) => {
    // const lastDotIndex = src.lastIndexOf('.');
    // const extension = filename.lastIndexOf('.');

    const path = src.slice(0, src.lastIndexOf('/') + 1);
    const filename = src.slice(src.lastIndexOf('/') + 1, src.lastIndexOf('.'));
    const extension = src.split('.').pop();

    return {
        small: `${path}optimized/${filename}-optimized@small.${extension}`,
        medium: `${path}optimized/${filename}-optimized@med.${extension}`,
        large: `${path}optimized/${filename}-optimized.${extension}`,
    };
};

export { getOptimized, getSmallestImage };

// loading="lazy"
// decoding="async"
